import { render, staticRenderFns } from "./UserBehavioral.vue?vue&type=template&id=8e3fa710&scoped=true&"
import script from "./UserBehavioral.vue?vue&type=script&lang=js&"
export * from "./UserBehavioral.vue?vue&type=script&lang=js&"
import style0 from "./UserBehavioral.vue?vue&type=style&index=0&id=8e3fa710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3fa710",
  null
  
)

component.options.__file = "UserBehavioral.vue"
export default component.exports